'use client';

import { CustomImage as Image } from 'components/shared/custom-image';
import React, { useRef } from 'react';
import { LinkWhite } from 'assets/icons';
import styles from './UHAppDownloadModal.module.css';

interface FlexProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'color'> {
  centerAlign?: boolean;
  centerJustify?: boolean;
  gap?: string;
  direction?: 'column' | 'row';
  className?: string;
  order?: number;
}

const Flex = ({
  centerAlign,
  centerJustify,
  gap,
  direction,
  order,
  className,
  style,
  children,
  ...rest
}: FlexProps) => {
  const flexVars = {
    '--flex-align': centerAlign ? 'center' : 'flex-start',
    '--flex-justify': centerJustify ? 'center' : 'flex-start',
    '--flex-gap': gap ?? 0,
    '--flex-direction': direction ?? 'row',
    ...(order !== undefined ? { '--flex-order': order } : {}),
  } as React.CSSProperties;

  return (
    <div
      {...rest}
      className={[styles.flex, className].filter(Boolean).join(' ')}
      style={{ ...flexVars, ...style }}
    >
      {children}
    </div>
  );
};

export const UhAppModal = ({
  className,
  text,
  link,
  image,
  heading,
  qr,
}: {
  className?: string;
  text?: string;
  link?: string;
  image?: string;
  heading?: string;
  qr?: React.ReactNode;
}) => {
  const actionDiv = useRef<HTMLDivElement | null>(null);

  const DEFAULT_LINK = 'https://ultrahuman.com';
  const DEFAULT_IMAGE = 'web_v2/UHAppQr.png';

  return (
    <div
      className={[styles.root, qr ? styles.stacked : '', className]
        .filter(Boolean)
        .join(' ')}
    >
        <Flex direction="row" style={{ justifyContent: 'space-between' }}>
          <Flex direction="column" centerAlign={Boolean(qr)}>
            {/* <Flex
                centerAlign={true}
                centerJustify={false}
                gap="6px"
                className="top-bar"
                order={1}
              >
              </Flex> */}
            <h3 style={{ order: 1 }}>{heading ?? 'Get the Ultrahuman App'}</h3>
            {text ? (
              <p
                style={{ order: 2 }}
                className={qr ? undefined : styles.desktopOnly}
              >
                {text}
              </p>
            ) : null}
            <Flex
              direction={qr ? 'column' : 'row'}
              order={5}
              gap={qr ? '18px' : undefined}
              style={{ alignItems: qr ? 'center' : 'end' }}
            >
              {qr ? (
                <div className={styles.qr}>{qr}</div>
              ) : (
                <Image
                  alt=""
                  src={image ?? DEFAULT_IMAGE}
                  width="100"
                  height="100"
                  className={styles.desktopOnly}
                  style={{ marginRight: '12px' }}
                />
              )}
              <div
                className={styles.copyLink}
                aria-hidden="true"
                onClick={() => {
                  if (!window) return;
                  window.navigator.clipboard
                    .writeText(link ?? DEFAULT_LINK)
                    .then(() => {
                      if (!actionDiv.current) return;
                      actionDiv.current.style.backgroundColor = '#008a05';
                      setTimeout(() => {
                        if (!actionDiv.current) return;
                        actionDiv.current.style.backgroundColor =
                          'rgba(0, 0, 0)';
                      }, 1500);
                    });
                }}
              >
                <div className={styles.linkContent}>{link ?? DEFAULT_LINK}</div>
                <div className={styles.copyActionElement} ref={actionDiv}>
                  <LinkWhite />
                </div>
              </div>
            </Flex>
            {/* change the url */}
            {/* <Link
              style={{ order: 4, marginBottom: '12px' }}
              href={link ?? DEFAULT_LINK}
              className="mobile-only"
            >
              <AppleAppStore className="mobile-only" />
            </Link> */}
          </Flex>
          {/* <Image
              alt=""
              src="web_v2/backgrounds/iphone_14_max_R1-2.png"
              width="150"
              height="324"
              className="desktop-only"
            /> */}
        </Flex>
      </div>
    );
};
